// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"69726dbf","490":"69726dbf","531":"69726dbf","534":"69726dbf","552":"69726dbf","629":"eb5a2667","686":"67f148ea","945":"69726dbf","991":"69726dbf"}[chunkId] + ".chunk.css";
};